
declare var Android: any;

var printCashpotTicket = (bettingDetails) => {
    Android.printCashpotTicket(bettingDetails);
}

var printPickJMTicket = (bettingDetails) => {
    Android.printPickJMTicket(bettingDetails);
}

var printLottoJMTicket = (res) => {
    Android.printLottoSuperLottoTicket(res);
}

var printTopDrawJMTicket = (res) => {
    Android.printTopDrawTicket(res);
}

var printLuckyFiveJMTicket = (res) => {
    Android.printLuckyFiveTicket(res);
}

var printDollazJMTicket = (res) => {
    Android.printDollazTicket(res);
}

var printTicketPay = (ticketPayData, locationOfPayment) => {
    Android.printTicketPay(ticketPayData, locationOfPayment);
}
var printTicketPayNew = (ticketPayData) => {
    Android.printTicketPayNew(ticketPayData);
}

var reprintTicketPayNew = (ticketPayData, userInfo) => {
    Android.reprintTicketPayNew(ticketPayData, userInfo);
}

export var androidBack = () => {
    Android.goBackToScreen();
}

var eodPrint = (eodData, userInfo) => {
    Android.eodPrint(eodData, userInfo);
}
var closeWebView = () => {
    Android.closeWebView();
}
var reprintCashpotTicket = (bettingDetails) => {
    Android.reprintCashpotTicket(bettingDetails);
}
var updateBalance = () => {
    Android.updateBalance();
}
var isPrinterConnected = () => {
    return Android.isPrinterConnected();
}
var cardClicked = (screen) => {
    return Android.cardClicked(screen);
}
var kioskVoucherRedemptionData = (data) => {
    return Android.kioskVoucherRedemptionData(data);
}
var forcedLogout = () => {
    return Android.forcedLogout();
}
var printChargeupEod = (eodData, staticData) => {
    Android.printChargeupEod(eodData, staticData);
}
var altenarPrint = (ticketPayData) => {
    Android.altenarPrint(ticketPayData);
}

var horseRacingPrint = (printData) => {
    Android.horseRacingPrint(printData);
}
var cartDetailTopDraw = (data) => {
    Android.cartDetailTopDraw(data);
}
var cartDetailLuckyFive = (data) => {
    Android.cartDetailLuckyFive(data);
}
var cartDetailDollaz = (data) => {
    Android.cartDetailDollaz(data);
}
var cartDetailLotto = (data) => {
    Android.cartDetailLotto(data);
}

var cartDetailPickThree = (data) => {
    Android.cartDetailPickThree(data);
}
var cartDetailSuperLotto = (data) => {
    Android.cartDetailSuperLotto(data);
}
var cartDetailPickFour = (data) => {
    Android.cartDetailPickFour(data);
}
var cartDetailPickTwo = (data) => {
    Android.cartDetailPickTwo(data);
}
var cartDetailCashpot = (data) => {
    Android.cartDetailCashpot(data);
}
var homePageCallBack =()=>{
    Android.homePageCallBack();
}
var cartDetailCommon =(data)=>{
    Android.cartDetailCommon(data);
}
export {
    printCashpotTicket, printTicketPay,
    eodPrint,
    closeWebView,
    reprintCashpotTicket,
    updateBalance,
    isPrinterConnected,
    cardClicked,
    printPickJMTicket,
    printLottoJMTicket,
    printTopDrawJMTicket,
    printLuckyFiveJMTicket,
    forcedLogout,
    printTicketPayNew,
    reprintTicketPayNew,
    printDollazJMTicket,
    printChargeupEod,
    altenarPrint,
    horseRacingPrint,
    cartDetailTopDraw,
    cartDetailLuckyFive,
    cartDetailLotto,
    cartDetailPickThree,
    cartDetailSuperLotto,
    cartDetailPickFour,
    cartDetailPickTwo,
    cartDetailCashpot,
    cartDetailDollaz,
    homePageCallBack,
    cartDetailCommon,
    kioskVoucherRedemptionData
}
